import { faPencil } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import styles from './EditCardImageButton.module.scss';
import type { ImagePosition } from './types';

// The pencil button and overlay that shows when hovering over a card.
export const EditCardImageButton = ({
  onClick,
  location,
}: {
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  location: ImagePosition;
}): JSX.Element => {
  return (
    <button className={styles['edit-image-overlay-btn']} data-location={location} onClick={onClick}>
      <FontAwesomeIcon icon={faPencil} className={styles['overlay-edit-image-icon']} />
    </button>
  );
};
